// extracted by mini-css-extract-plugin
export default {"cls1":"MLsEZK2Y0eea86_QxUze","cls2":"AlUvxsGfRlU3p89dqT7x MLsEZK2Y0eea86_QxUze"};